import { EQUALISATIONS } from 'adminConstants/routes';
import Page from 'components/new/Page';
import { PropsWithChildren } from 'react';

type Props = {
  subheading?: string | React.ReactNode;
  actionBar?: React.ReactNode;
};

const EqualisationPage: React.FC<PropsWithChildren<Props>> = ({
  subheading,
  children,
  actionBar,
}) => {
  return (
    <Page
      tabTitle="Close & Equalise: Add Close"
      spacing="lg"
      withHeadingDivider
      goBackAction={EQUALISATIONS}
      heading="Close and equalise"
      subheading={subheading}
      actionBar={actionBar}
    >
      {children}
    </Page>
  );
};

export default EqualisationPage;
